import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"
import Honeybadger from "@honeybadger-io/js"

export default class extends Controller {
  static targets = ["list", "item", "handle"]
  static values = { url: String }

  initialize() {}

  connect() {
    // New pattern: controller on container with url value and item targets
    if (this.hasUrlValue) {
      this.initializeBatchSortable()
    }
    // Legacy pattern: list targets with individual item urls
    else if (this.hasListTarget) {
      this.initializeLegacySortable()
    }
  }

  initializeBatchSortable() {
    const handleSelector = this.hasHandleTarget ? '[data-sortable-target="handle"]' : undefined

    new Sortable(this.element, {
      draggable: '[data-sortable-target="item"]',
      handle: handleSelector,
      animation: 150,
      ghostClass: "bg-ghost",
      onEnd: this.handleBatchReorder.bind(this),
    })
  }

  handleBatchReorder(_event) {
    const items = this.element.querySelectorAll('[data-sortable-target="item"]')
    const positions = []

    items.forEach((item, index) => {
      const id = item.getAttribute("data-id")
      if (id) {
        positions.push({ id: parseInt(id), position: index + 1 })
      }
    })

    const token = document.head.querySelector('meta[name="csrf-token"]').getAttribute("content")

    fetch(this.urlValue, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": token,
        Accept: "application/json",
        "Content-type": "application/json",
      },
      body: JSON.stringify({ positions: positions }),
    })
      .then((response) => {
        if (!response.ok) throw new Error(`sortable batch reorder failed: ${response.status}`)
      })
      .catch((error) => {
        // The DOM was reordered optimistically; a failed save (expired session, network drop)
        // must not stand as if it stuck. Reload to snap back to server truth — visibly.
        Honeybadger.notify(error, {
          context: { component: "sortable:batch-reorder", url: this.urlValue },
        })
        window.location.reload()
      })
  }

  initializeLegacySortable() {
    this.listTargets.forEach((column) => {
      new Sortable(column, {
        draggable: "li",
        animation: 150,
        ghostClass: "bg-ghost",
        onEnd: function (event) {
          const url = event.item.getAttribute("data-url")
          const item_class = event.item.getAttribute("data-item-class")
          const data = {}
          data[item_class] = { position: event.newIndex + 1 }
          const token = document.head
            .querySelector('meta[name="csrf-token"]')
            .getAttribute("content")
          fetch(url, {
            method: "PATCH",
            credentials: "same-origin",
            headers: {
              "X-CSRF-Token": token,
              Accept: "application/json",
              "Content-type": "application/json",
            },
            body: JSON.stringify(data),
          })
        },
      })
    })
  }

  disconnect() {}
}
